import { ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { configuredModerationToolLinks, openExternalUrl } from '@/lib/moderationToolLinks';

interface ModerationToolLinksProps {
  className?: string;
  compact?: boolean;
}

/** Header row on the moderation list — opens Coop / Osprey in a new tab (Entra SSO at the edge). */
export function ModerationToolLinks({ className, compact = false }: ModerationToolLinksProps) {
  const links = configuredModerationToolLinks();
  if (links.length === 0) {
    return null;
  }

  return (
    <div className={className}>
      {!compact && (
        <div className="mb-3">
          <p className="text-sm font-medium">Policy tools</p>
          <p className="mt-1 text-xs text-muted-foreground">
            Sign in with the same Microsoft account as TipMi Admin.
          </p>
        </div>
      )}
      <div className="flex flex-wrap gap-3">
        {links.map((link) => {
          const Icon = link.icon;
          return (
            <Button
              key={link.url}
              variant="outline"
              size="sm"
              onClick={() => openExternalUrl(link.url)}
            >
              <Icon className="size-4" />
              <span className="ml-2">{link.label}</span>
              <ExternalLink className="ml-2 size-3.5 opacity-70" aria-hidden />
              <span className="sr-only">Opens in new tab</span>
            </Button>
          );
        })}
      </div>
    </div>
  );
}
